/**
 * @description 婚姻狀況用
*/
export enum Marriage {
  /** 未婚 */
  Single = '0',
  /** 已婚 */
  Married = '1'
}
